import { Card } from 'semantic-ui-react'

export default function PermitDashboardInfo() {
    return (
        <Card.Group itemsPerRow={3} stackable doubling>
            <Card color='teal'>
                <Card.Content>
                    <Card.Header>Your WSF Carpool/Vanpool Account</Card.Header>
                    <Card.Description>
                    Thank you for participating in WSF's Carpool and Vanpool program. From this page you can edit your account information and purchase or renew your Carpool or Vanpool permit.
                    </Card.Description>
                </Card.Content>
            </Card>
            <Card color='teal'>
                <Card.Content>
                    <Card.Header>WSF Account Privacy</Card.Header>
                    <Card.Description>
                    WSF has a strict Customer Privacy Policy and WSF does not share your personal information.
                    </Card.Description>
                </Card.Content>
            </Card>
            <Card color='teal'>
                <Card.Content>
                    <Card.Header>Shipping and Billing Addresses</Card.Header>
                    <Card.Description>
                    If a separate addresses are not indicated, your primary account address will automatically be used.
                    </Card.Description>
                </Card.Content>
            </Card>
        </Card.Group>
    )
}